import { render, staticRenderFns } from "./ExpenseCodeBlock.vue?vue&type=template&id=097f79c4&lang=pug&"
import script from "./ExpenseCodeBlock.vue?vue&type=script&lang=js&"
export * from "./ExpenseCodeBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports